import { render, staticRenderFns } from "./PurchaseOrderItem.vue?vue&type=template&id=1f046bde"
import script from "./PurchaseOrderItem.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f046bde')) {
      api.createRecord('1f046bde', component.options)
    } else {
      api.reload('1f046bde', component.options)
    }
    module.hot.accept("./PurchaseOrderItem.vue?vue&type=template&id=1f046bde", function () {
      api.rerender('1f046bde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchaseorder/PurchaseOrderItem.vue"
export default component.exports